import { Gender } from '../ts/enums/Gender';

export const genderOptions = [
  { label: Gender.Man, value: Gender.Man },
  { label: Gender.Woman, value: Gender.Woman },
  { label: Gender.NonBinary, value: Gender.NonBinary },
  { label: Gender.Other, value: Gender.Other },
];
